import {useLayoutEffect, useState, useRef, useEffect} from 'react'

export default function Collapse(props) {
    const {children, duration, delay, collapsed, setCollapsed} = props; 
    const [dimensions, setDimensions] = useState(null); 
    const [height, setHeight] = useState('fit-content'); 
    const [transition, setTransition] = useState(false)
    const collapseElement = useRef(null); 


    useLayoutEffect(() => {
        setDimensions(collapseElement.current.getBoundingClientRect()); 
        setCollapsed(true); 
        setHeight('0px')
    }, [])

    useEffect(() => {
        if(dimensions) setTransition(true); 
    }, [dimensions])

    useEffect(() => {
        if(!collapsed && dimensions) setHeight(`${dimensions.height}px`)
        if (collapsed) setHeight('0px'); 
    }, [collapsed])

    return (
        <div ref={collapseElement} className={`${collapsed ? 'collapsed' : null}`} style={{overflow: 'hidden', height: height, transition: transition ? `height ${duration || 1000}ms ease-in-out ${delay || 0}ms` : null }}>
            {children}
        </div>
    )
}
